import { useState } from "react";
import ContentDrawer from "./ContentDrawer";

const CreativeName = ({ row }) => {
    const [showAdDetails, setShowAdDetails] = useState(false);
    const isPackage = row?.creative_type === 'PACKAGE' && row?.package_weeks;
    const packageIndex = isPackage && row?.package_position ? row.package_position : null;
    return (
        <div>
            <div className="flex flex-col gap-0.5 justify-start items-start">
                <span className="text-[10px] uppercase tracking-wide text-gray-400 font-semibold">CREATIVE</span>
                <div className="flex gap-2 items-center">
                    <span className="font-semibold text-gray-800">{row?.creative_name}</span>
                    {isPackage && (
                        <span className="flex gap-1 items-center bg-purple-100 text-purple-700 rounded-md px-1.5 py-0.5 text-xs font-semibold">
                            {packageIndex ? `${packageIndex}/${row.package_weeks}` : row.package_weeks}
                            <sl-icon title="Package Order" name="gift" library="lucide"></sl-icon>
                        </span>
                    )}
                    <sl-icon-button library="lucide" name="eye" onClick={() => setShowAdDetails(true)}></sl-icon-button>
                </div>
                {row?.brand_name && <span className="text-xs text-gray-500">brand : {row?.brand_name}</span>}
                {row?.client_name && <span className="text-xs text-gray-500">client : {row?.client_name}</span>}
            </div>
            <ContentDrawer isOpen={showAdDetails} onClose={() => setShowAdDetails(false)} type="adDetails" rowData={row} />
        </div>
    );
};

export default CreativeName;
